import { useTranslation } from 'react-i18next';

import * as Styled from './DesktopOnlyMessage.styles';

// TIC-332: Marketing Campaigns has a wide desktop-oriented layout and is intentionally gated to
// desktop widths. The previous fallback rendered a single bare title-styled line, which read as
// "the content disappeared". This presents the gate as a clear, centered message instead.
export const DesktopOnlyMessage = ({ isPunchup = false }: { isPunchup?: boolean }) => {
	const { t } = useTranslation();

	return (
		<Styled.Container>
			<Styled.Title isPunchup={isPunchup}>{t('marketing-viewEmailCampaigns-mobileOnly')}</Styled.Title>
			<Styled.Description isPunchup={isPunchup}>
				{t('marketing-viewEmailCampaigns-mobileOnly-description')}
			</Styled.Description>
		</Styled.Container>
	);
};
